<template>
  <v-dialog
    v-model="computedDialog"
    @click:outside="hideCloseButton || $emit('close')"
    :persistent="hideCloseButton"
    :width="customWidth">
    <v-card id="mapit-dialog" :class="[customId, 'px-[60px] py-[40px]']" :data-cy="customId">
      <v-card-title :class="$slots['header-icon'] || $slots['header-text'] ? 'header-title' : 'header-title-reduced'">
        <span class="close-dialog" @click="$emit('close')" v-if="!hideCloseButton">
          <v-icon class="icon-mapit mt-2 mr-1">x</v-icon>
        </span>
        <v-row no-gutters class="full-width" :class="$slots['header-icon'] ? 'text-center' : 'text-left'">
          <v-col class="col-12 big-icon pb-[16px]" v-if="$slots['header-icon']">
            <slot name="header-icon" />
          </v-col>
          <v-col class="col-12 header-text-wrapper">
            <slot name="header-text" />
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text class="dialog-content" v-if="$slots.body">
        <slot name="body" />
      </v-card-text>

      <v-card-actions class="footer-actions" v-if="$slots['footer-left'] || $slots['footer-right']">
        <slot name="footer-left" />
        <div class="footer-divider" />
        <slot name="footer-right" />
      </v-card-actions>
      <v-card-actions class="footer-actions" v-else-if="$slots['footer-center']">
        <div class="footer-divider" />
        <div class="equal-space-grid" v-balance-text.children>
          <slot name="footer-center" />
        </div>
        <div class="footer-divider" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import {defineComponent, nextTick, onMounted, ref, watch} from '@vue/composition-api'

export default defineComponent({
  name: 'MapitDialog',
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
    customWidth: {
      type: String,
      default: '550px',
    },
    customId: {
      type: String,
      default: 'mapit-dialog',
    },
  },
  setup(props, {slots}) {
    const computedDialog = ref(props.dialog)
    const footerCenterItemCount = ref(0)

    watch(
      () => props.dialog,
      value => {
        computedDialog.value = value
      },
    )

    onMounted(async () => {
      await nextTick()
      footerCenterItemCount.value = slots['footer-center'] ? slots['footer-center'].length : 0
    })

    return {
      computedDialog,
      footerCenterItemCount,
    }
  },
})
</script>

<style lang="scss">
#mapit-dialog {
  padding-left: 40px;
  padding-right: 40px;
  border-radius: 8px !important;

  .header-title {
    padding: 0 !important;
    color: black;
    font-size: 24px !important;
    letter-spacing: 0.48px;
    text-transform: uppercase;
    font-family: 'ProximaNovaExCnSbold', sans-serif;
  }

  .dialog-content {
    color: black;
    padding: 0 !important;
    margin-top: 8px;
    font-family: 'ProximaNovaRegular', sans-serif;
    font-size: 15px;

    b {
      font-family: 'ProximaNovaSemibold', sans-serif;
    }

    & + .footer-actions {
      padding-top: 32px !important;
    }
  }

  .footer-actions {
    padding: 0 !important;

    .footer-divider {
      flex: 1;
    }
  }
}

.big-icon i {
  font-size: 48px !important;

  &.text {
    &-primary {
      color: var(--v-primary-base);
    }

    &-secondary {
      color: var(--v-secondary-base);
    }

    &-orange {
      color: var(--v-warning-base);
    }
  }
}

.p-24 {
  padding: 24px !important;
}
.px-\[60px\] {
  padding-left: 60px !important;
  padding-right: 60px !important;
}

.py-\[40px\] {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}

.pb-\[16px\] {
  padding-bottom: 16px !important;
}

.close-dialog {
  position: absolute;
  right: 20px;
  top: 12px;
  cursor: pointer;
}
.equal-space-grid {
  display: grid;
  grid-auto-flow: column; /* column flow */
  justify-content: center; /* center everything */
  grid-auto-columns: 1fr;
  grid-gap: 10px;
}
</style>
